import React from "react";
import "./css/errorpopup.css";

const ErrorPopup = ({ message, onClose }) => {
if (!message) return null;

return (
<div className="error-popup-content">
<button className="error-popup-close" onClick={onClose}>×</button>
<p>{message}</p>
</div>
);
};

export default ErrorPopup;


// usage
// <ErrorPopup message={error} onClose={() => setError(null)} />